import { StepConfig } from '../../../../models';
import { ConfigTreeNode } from '../models';
import { buildStepConfigTree } from './buildStepConfigTree';

describe('buildStepConfigTree()', () => {
  type Case = {
    name: string;
    stepConfigs: StepConfig[];
    expectedConfigNodes: Map<string, ConfigTreeNode>;
  };

  /*
    The following threeLayerCase should look like the following diagram:
          ┌──────┐
          │ root │
          └──┬───┘
              │
          ┌───┴───┐
    ┌─────┤       ├────┐
    │  a  │       │ b  │
    └──┬──┘       └────┘
      │
    ┌──┴──┐
    │  a1 │
    └─────┘
 */
  const rootStepConfig = {
    name: 'root',
    uses: ''
  };
  const aStepConfig = {
    name: 'a',
    uses: '',
    needs: {
      name: 'root'
    }
  };
  const a1StepConfig = {
    name: 'a1',
    uses: '',
    needs: {
      name: 'a'
    }
  };
  const bStepConfig = {
    name: 'b',
    uses: '',
    needs: {
      name: 'root'
    }
  };

  // expected tree nodes
  const rootNode = {
    config: rootStepConfig,
    stepInstances: []
  };

  const aNode = {
    config: aStepConfig,
    stepInstances: [],
    parent: rootNode
  };

  const a1Node = {
    config: a1StepConfig,
    stepInstances: [],
    parent: aNode
  };

  const bNode = {
    config: bStepConfig,
    stepInstances: [],
    parent: rootNode
  };

  const threeLayerCase: Case = {
    name: 'when config tree is valid with multiple layers and branches',
    stepConfigs: [rootStepConfig, aStepConfig, a1StepConfig, bStepConfig],
    expectedConfigNodes: new Map([
      ['root', rootNode],
      ['a', aNode],
      ['a1', a1Node],
      ['b', bNode]
    ])
  };

  const singleRootNodeCase: Case = {
    name: 'when config tree is valid with single root node',
    stepConfigs: [rootStepConfig],
    expectedConfigNodes: new Map([['root', rootNode]])
  };

  describe.each([threeLayerCase, singleRootNodeCase])('$name', ({ stepConfigs, expectedConfigNodes }) => {
    it('should build a tree from the given step configs', () => {
      const actualConfigNodes = buildStepConfigTree(stepConfigs);
      expect(actualConfigNodes).toEqual(expectedConfigNodes);
    });
  });
});
